import "./JobCard.scss"
import Location from '../../images/Icon-material-location-on.png'

function JobCard({image, company, location, role, desc, postedOn, salary }) {

  return (
    <div className="job-card">
      <div className="company-details">
        <img className="profile-img" src={image} alt="Profile Pic" />
        <div className="company-wrp">
          <div className="company">{company}</div>
          <div className="location">
            <img className="icon-img" src={Location} alt="Icon"/>
            <div className="place">{location}</div>
          </div>
        </div>
      </div>
      <div className="role">{role}</div>
      <div className="desc">{desc}</div>
      <div className="salary-wrp">
        <div className="postedOn">{postedOn}</div>
        <div className="salary-details">
          <div className="salary">{salary?.amount}/</div>
          <div className="cycle">{salary?.cycle}</div>
        </div>
      </div>
    </div>
  );
}

export default JobCard;
